import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'event'
})
export class EventPipe implements PipeTransform {

  transform(value: any, date : string , startTime: string, endTime : string, isFreeze : boolean, isCount: boolean): any {
    let monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    if( value !== undefined) {
      
        if(isFreeze===false) {
          let tasks =   value.Days.filter((data)=> 
            data.date === date   
          );
          if(tasks.length>0) {
              let tasksForTime = tasks[0].tasks.filter((task) =>
                new Date(date + ' ' + task.Time) >= new Date(date + ' ' + startTime) && new Date(date + ' ' + task.Time) <= new Date(date + ' ' + endTime)   
              )
              if(isCount) {
                return false;
              } else {
                return [{"date": date,"tasks" : tasksForTime}];
              }

             
          } else {
            if(isCount) {
              return true;
            } else {
              return tasks;
            }
            
          }
        } else {
          if(value.length>0) {
            let tasks =   value.filter((data)=> 
                (data.StartDate.split('/')[0]+'-' + monthShortNames[parseInt(data.StartDate.split('/')[1])-1] +'-' +data.StartDate.split('/')[2]) === date
                  //     
              );
          
            if(tasks.length>0) {
                let tasksForTime = tasks[0].AppointmentSchedule.filter((task) =>
                  new Date(date + ' ' + task.AppointmentTime) >= new Date(date + ' ' + startTime) && new Date(date + ' ' + task.AppointmentTime) <= new Date(date + ' ' + endTime)   
                )
                if(tasksForTime.length>0 && tasksForTime[0].AppointmentIsScheduledActive===false) {
                  return true;
                } else {
                  return false;
                }
            } else {
              return false;
            }
          } else {
             return false;
          }
        }
        
    } else {
      if(isFreeze===false) {
        if(isCount) {
           return false;
        } else {
          return [{"date": date,"tasks" : []}];
        }
         
      } else {
        return false;
      }
    }




  }

}



// WEBPACK FOOTER //
// ./src/app/section/appointment/calendar/event.pipe.ts